import React from "react";
import { Controller } from "react-hook-form";

const RadioButtonGroup = ({
  name,
  control,
  options = [],
  defaultValue = "",
  rules = {},
  label = "",
  error = null,
  className = "",
  direction = "horizontal",
  noWrap = false,
  optionLabelClassName = "text-sm",
}) => {
  const isGridThree = direction === "grid-3";
  const optionsLayoutClass = isGridThree
    ? "grid grid-cols-3 items-center gap-x-2 gap-y-1"
    : `flex items-center ${noWrap ? "flex-nowrap" : "flex-wrap"} gap-x-2 gap-y-2`;

  return (
    <div className={`${className}`}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field }) => (
          <div className={optionsLayoutClass}>
            {/* Inline Label (only if provided) */}
            {label && (
              <span className="text-sm font-medium text-gray-700  select-none">
                {label}:
              </span>
            )}

            {/* Radio Options */}
            {options.map(({ label: optionLabel, value }) => {
              const isChecked = field.value === value;

              return (
                <label
                  key={value}
                  className="flex items-center cursor-pointer select-none transition-colors duration-200 hover:text-[#217E90]"
                >
                  <input
                    type="radio"
                    value={value}
                    checked={isChecked}
                    onChange={field.onChange}
                    className="sr-only"
                  />
                  <span
                    className={`
                      relative w-4 h-4 rounded-full border-2 flex-shrink-0 mr-2 transition-all
                      ${isChecked ? "border-[#217E90]" : "border-gray-300"}
                    `}
                  >
                    {isChecked && (
                      <span className="absolute inset-1 rounded-full bg-[#217E90]" />
                    )}
                  </span>
                  <span
                    className={`${optionLabelClassName} leading-none ${
                      isChecked ? "text-[#217E90] font-medium" : "text-gray-700"
                    } whitespace-nowrap`}
                  >
                    {optionLabel}
                  </span>
                </label>
              );
            })}
          </div>
        )}
      />

      {/* Error */}
      {/* {error && <p className="mt-1 text-sm text-red-600">{error.message}</p>} */}
    </div>
  );
};

export default RadioButtonGroup;
